import { Box, HStack, Stack, VStack } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import { OnboardingCompanyQuery } from 'features/Onboarding/graphql/queries/onboardingCompany.gql';
import { formatDate } from 'helpers/date';

import locales from './locales';

interface ResetOnboardingPromptProps {
  onResume: () => void;
  onAbort: () => void;
  company: Pick<
    OnboardingCompanyQuery['viewer']['company']['profile'],
    'legalName' | 'tradeName' | 'legalRegistrationNumber' | 'registrationDate'
  >;
}

const ResetOnboardingPrompt = asBentoPage<ResetOnboardingPromptProps>(
  ({ company, Layout, onAbort, onResume }) => {
    return (
      <Layout nav={<OBNavigation />}>
        <Box>
          <Header
            description={locales.description}
            imageWidthPx={100}
            title={locales.title}
          />

          <VStack align="stretch" as={Card} spacing="space-16">
            {company.tradeName ? (
              <Box>
                <Card.Title fontSize="font-18">{company.tradeName}</Card.Title>

                <Text size="sm" variant="light">
                  {company.legalName}
                </Text>
              </Box>
            ) : (
              <Card.Title fontSize="font-18">{company.legalName}</Card.Title>
            )}

            <HStack justify="space-between">
              {company.registrationDate ? (
                <Box>
                  <Text size="sm">{locales.registrationDateLabel}</Text>
                  <Text fontWeight="weight-500" variant="primary">
                    {formatDate(new Date(company.registrationDate), 'PPP')}
                  </Text>
                </Box>
              ) : null}

              {company.legalRegistrationNumber ? (
                <Box>
                  <Text size="sm">{locales.siretLabel}</Text>
                  <Text fontWeight="weight-500" variant="primary">
                    {company.legalRegistrationNumber}
                  </Text>
                </Box>
              ) : null}
            </HStack>
          </VStack>

          <Text marginTop="space-24">{locales.prompt}</Text>

          <Stack
            align="stretch"
            direction={{ base: 'column-reverse', sm: 'row' }}
            marginTop="space-16"
            spacing="space-16"
            width="full"
          >
            <Button
              icon="trash"
              iconPosition="left"
              onClick={onAbort}
              variant="danger"
            >
              {locales.cta.restart}
            </Button>

            <Button icon="arrow-right" onClick={onResume}>
              {locales.cta.resume}
            </Button>
          </Stack>
        </Box>
      </Layout>
    );
  },
);

export default ResetOnboardingPrompt;
